export const variables = {
  shareUrl: 'share',
  businessUrl: 'business-id',
  inviteCode: 'invite',
  languageCodeStorageKey: 'LOCALIZE_DEFAULT_LANGUAGE',
  defaultLanguage: 'en',
  websocketAipUrlKey: 'WEBSOCKET_API_URL',
  businessEntityIdParam: 'business-entity-id',
  defaultRedirectPage: '/',
  authCode: 'auth_code',
  erpLoginReturUrlQueryParam: 'returnUrl',
  builderThemeStorageKey: 'offconon-template-builder-theme',
  loginSectionResponseStorageKey: 'loginSectionResponse',
  browserFingerprintStorageKey: 'client_fingerprint',
  businessIdStorageKey: 'offconon-business-id',
  adultContentAcceptedStorageKey: 'offconon_adult_content_accepted',
  adultApps: ['erotic'],
};
